import { render, staticRenderFns } from "./PresentationOwner.vue?vue&type=template&id=8354be64&scoped=true&"
import script from "./PresentationOwner.vue?vue&type=script&lang=js&"
export * from "./PresentationOwner.vue?vue&type=script&lang=js&"
import style0 from "./PresentationOwner.vue?vue&type=style&index=0&id=8354be64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8354be64",
  null
  
)

export default component.exports